import { Component, OnInit,HostListener } from '@angular/core';
import { HelperService } from '../helper.service';
import { Router,ActivatedRoute, Params } from '@angular/router';
import {MatSnackBar} from '@angular/material';
import { Http, Response,Headers } from '@angular/http';

import { Subject } from 'rxjs/Subject';
import { NgForm } from '@angular/forms';
import { DataTableDirective } from 'angular-datatables';
import {CookieService} from 'angular2-cookie/core';
import {SnackbarComponent} from '../snackbar/snackbar.component';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.css'],
   providers: [HelperService] 
})
export class NotificationComponent implements OnInit {
  // 	@HostListener('window:beforeunload', ['$event'])
//   unloadHandler(event: Event) {
//   localStorage.removeItem('access_token');
//   localStorage.removeItem('navigateroute');
// }
  dtOptions: DataTables.Settings = {};
  dtElement: DataTableDirective;
  dtTrigger: Subject<any> = new Subject();
  notifications;
  list=true;
  add=false;
  icon=this.helper.add_icon;
  icon_action='addClick';
  notificationdisbled =false;
  notifcatonloading = false;
  user_permissions:any=[];
  user=this.cookie.get('user_id');
  user_token= localStorage.getItem('access_token');
  private headers: Headers = new Headers({
  'Accept': 'application/json',
  'Authorization': "Bearer "+this.user_token
});
   constructor(private helper:HelperService,private http:Http,private snackbar: MatSnackBar,private activatedRouter:ActivatedRoute,private router:Router,private cookie:CookieService) {
   }

  ngOnInit() {
    let user=this.cookie.get('user_id');
    this.http.get(this.helper.base_url+'/http/get/user/permissions',{ headers: this.headers })
    
    .subscribe(data => {
      this.user_permissions = JSON.parse(data['_body']);
     //console.log(this.user_permissions);
        
     
    });
    //this.notificationdisbled = true;
    this.http.get(this.helper.base_url+'http/get/notifications',{ headers: this.headers })
      
      .subscribe(data => {
        this.notifications = JSON.parse(data['_body']);
        
          this.dtTrigger.next();
        
       
      });

       this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10
    };
  }
   send_form(sendForm: NgForm){
    if(confirm("Are you sure to send the notification")) 
    {
     this.notificationdisbled = true;
     this.notifcatonloading = true;
    //  $(".preloader").css("display", "block");
   	 let body = new FormData();
     body.append('title', sendForm.value.title);
     body.append('body', sendForm.value.body);
     //body.append('user',this.user);
		 this.http.post(this.helper.base_url+'http/send/notification',body,{ headers: this.headers })
     
      .subscribe(res => {
        $(".preloader").css("display", "none");
        this.notificationdisbled = false;
        this.notifcatonloading = false;
      	 this.refresh(false,'Notification send successfully') ;
      },err => { 
        this.notifcatonloading = false;
        this.snackbar.open("Error Sending Notifications", null, {
          duration:5000,
            extraClasses:'error-snackbar',
            verticalPosition:'top'
          });
      console.error(err)
    });
    }
   }
    refresh(val=false,msg){
   
  this.snackbar.open(msg, null, {
    duration:5000,
      extraClasses:'success-snackbar',
      verticalPosition:'top'
    });
  this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
  this.router.navigate(["notification/"]));
      
 }
 addClick(e){
    
  this.list=false;
  this.add=true;
  this.icon=this.helper.list_icon;
  
  this.icon_action="listClick";
}
listClick(e){
  this.list=true;
  this.add=false;
  this.icon=this.helper.add_icon;
  this.icon_action="addClick";
}
delete_form(id){
  let snackBarRef = this.snackbar.openFromComponent(SnackbarComponent, {
  //this.snackbar.open('Are you sure!', 'Delete', {
    duration: 3000,
    extraClasses:  ['warning-snackbar'],
  }).onAction().subscribe(() => {
    this.http.get(this.helper.base_url+'http/delete/notification/'+id,{ headers: this.headers })
    .subscribe(
       
        (data) =>  this.refresh(false,'Notification Removed successfully'), //For Success Response
        err => {console.error(err)} //For Error Response
    ); 
  });
 
}

}



// WEBPACK FOOTER //
// ./src/app/notification/notification.component.ts